module.exports = __webpack_public_path__ + "static/img/sm_12.9f80186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_12.png
// module id = XO19
// module chunks = 0